export const APP_TYPES = {
  ADMIN: 'admin',
  BUSINESS_USER: 'businessuser',
  MERCHANT: 'merchant',
};

export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  MANAGER: 'manager',
  USER: 'user',
};

export const STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  PENDING: 'pending',
  SUSPENDED: 'suspended',
};

export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
};

export const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes

export const SKIP_LOGIN_REDIRECT = false;

export default {
  APP_TYPES,
  USER_ROLES,
  STATUS,
  PAGINATION,
  SESSION_TIMEOUT,
  SKIP_LOGIN_REDIRECT,
};
